import request from '@/utils/request'

// 查询韩国出口受阻通报列表
export function listReport(query) {
  return request({
    url: '/web/zlts/bzfw/hgOutBlockReport/list',
    method: 'get',
    params: query
  })
}